import React from 'react';
import './StayConnected.css';

const StayConnected: React.FC = () => {
  return (
    <section className="stay-connected-section">
      <div className="stay-connected-content">
        <h2 className="stay-connected-title impact">Ready to elevate your performance?</h2>
        <p className="stay-connected-subtitle">
          Join Phase Fitness for AI-powered workouts and nutrition tracking, or download Phase Pal on Steam for your gaming companion. Get started today and transform how you train and play.
        </p>
        <div className="stay-connected-buttons">
          <a href="https://youtu.be/GWu0iY_5KVA?si=bTASvfPjZjjvRZnv" target="_blank" rel="noopener noreferrer" className="stay-connected-button">Watch Trailer</a>
          <a href="https://store.steampowered.com/app/3655450/Phase_Pal/" target="_blank" rel="noopener noreferrer" className="stay-connected-button steam-button">Download on Steam</a>
        </div>
      </div>
    </section>
  );
};

export default StayConnected; 